import axios from 'axios';
import idHeaders from '../interceptors/idHeaders';
import csrfHeaders from '../interceptors/csrfHeaders';
import retryCallIfNeeded from '../../restCalls';

const basePath = window.__ENV.REACT_APP_BASE_PATH || '/application';
const adminBase = `${basePath}/admin`;

const maintenanceEndpoint = '/service/maintenance';
const adminEndpoint = '/login';

// Dedicated client so CSRF wiring stays scoped to admin requests and does not
// mutate the shared global axios instance used by other services.
// csrfHeaders attaches the CSRF-Token (from the CSRF-Token cookie set on SPA
// load) required by the csrf.check middleware on the admin POST routes.
const adminClient = axios.create({});
adminClient.interceptors.request.use(idHeaders);
adminClient.interceptors.request.use(config => csrfHeaders(config));

export default function AdminService() {
  const setServerMaintenance = async payload => retryCallIfNeeded(adminClient, () => adminClient
    .post(`${adminBase}${maintenanceEndpoint}`, payload), 1);
  const getServerMaintenance = async () => retryCallIfNeeded(adminClient, () => adminClient
    .get(`${adminBase}${maintenanceEndpoint}`));

  const adminLogin = async payload => retryCallIfNeeded(adminClient, () => adminClient
    .post(`${adminBase}${adminEndpoint}`, payload), 1);

  return {
    setServerMaintenance,
    getServerMaintenance,
    adminLogin,
  };
}
